import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useAxiosInstance } from "../../../services/Interceptor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { getCoaches } from "../../../store/CoachActions";

function SearchCoaches({ searchCoachFn }) {
  const apiInstance = useAxiosInstance();
  const dispatch = useDispatch();
  const querySearch = useRef();

  const handleSearch = async (event) => {
    event.preventDefault();
    if (querySearch.current) {
      dispatch(getCoaches(apiInstance, querySearch.current.value));
    }
  };

  useEffect(() => {
    dispatch(getCoaches(apiInstance, ""));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <div className="mb-0">
      <form
        className="mb-4 flex items-center w-full border border-gray-300 rounded-md overflow-hidden"
        onSubmit={handleSearch}
      >
        <input
          type="text"
          ref={querySearch}
          placeholder="Search Coaches ..."
          onChange={searchCoachFn}
          className="px-4 py-2 basis-11/12 focus:outline-none"
        />
        <button
          type="button"
          className="mr-2 basis-1/12 bg-white text-slate-500 flex items-center justify-center rounded-lg "
        >
          <FontAwesomeIcon icon={faSearch} size="xl" />
        </button>
      </form>
    </div>
  );
}

export default SearchCoaches;
